import React, { useState, useEffect, useContext } from 'react';
import { useLocation } from "react-router-dom";
import axios from 'axios';
import { config } from '../../config';
import { UserContext } from '../../context/UserContext';
import { converterData } from '../../util';
import styles from './GerenciarCadastros.module.css';

// Função para calcular a quantidade de dias desde a data de entrega
const calcularDiasAtivos = (dataEntrega) => {
    const dataAtual = new Date();
    const dataEntregaDate = new Date(dataEntrega);
    const diffTime = dataAtual - dataEntregaDate;
    return Math.floor(diffTime / (1000 * 60 * 60 * 24));
};

function Historico() {
    const { codigoCondominio } = useContext(UserContext);

    const [encomendas, setEncomendas] = useState([]);
    const [filteredEncomendas, setFilteredEncomendas] = useState([]);
    const [bloco, setBloco] = useState('');
    const [unidade, setUnidade] = useState('');
    const [statusEncomenda, setStatusEncomenda] = useState(null);
    const [expandedIndex, setExpandedIndex] = useState(null);

    const location = useLocation();
    const [statusSelecionado, setStatusSelecionado] = useState(""); // Estado para o filtro de status

    // Paginação
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Mostra 4 itens por página

    useEffect(() => {
        if (codigoCondominio) {
            axios.get(`${config.apiBaseUrl}/encomenda/listarTodas/${codigoCondominio}`)
                .then(response => {
                    if (response.data && Array.isArray(response.data)) {
                        console.log("Dados recebidos do backend:", response.data);

                        const encomendasOrdenadas = [...response.data].sort((a, b) => {
                            // Verifica se uma encomenda está ativa
                            const isAtivaA = !a.DH_RET || a.DH_RET === "0001-01-01T00:00:00";
                            const isAtivaB = !b.DH_RET || b.DH_RET === "0001-01-01T00:00:00";

                            // Ordena as ativas por data de entrega (mais antiga para mais recente)
                            if (isAtivaA && isAtivaB) {
                                return new Date(a.DH_GER) - new Date(b.DH_GER);
                            }

                            // Mantém as retiradas na ordem decrescente por data de retirada
                            if (!isAtivaA && !isAtivaB) {
                                return new Date(b.DH_RET) - new Date(a.DH_RET);
                            }

                            // As ativas vêm antes das retiradas
                            return isAtivaA ? -1 : 1;
                        });

                        setEncomendas(encomendasOrdenadas);
                        setFilteredEncomendas(encomendasOrdenadas);
                    } else {
                        setEncomendas([]);
                        setFilteredEncomendas([]);
                    }
                })
                .catch(error => {
                    console.error('Erro ao buscar encomendas:', error);
                    setEncomendas([]);
                    setFilteredEncomendas([]);
                });
        }
    }, [codigoCondominio]);



    // Função para filtrar as encomendas com base nos filtros selecionados
    useEffect(() => {
    const filtered = encomendas.filter((encomenda) => {
        const matchBloco = bloco.trim() === '' || 
            (encomenda.BLOCO && encomenda.BLOCO.toString().toLowerCase().includes(bloco.trim().toLowerCase()));
        const matchUnidade = unidade.trim() === '' || 
            (encomenda.NR_CASA && encomenda.NR_CASA.toString().includes(unidade.trim()));
        const matchStatus =
            statusEncomenda === null || // Exibe todas as encomendas
            (statusEncomenda === false && (!encomenda.DH_RET || encomenda.DH_RET === "0001-01-01T00:00:00")) || // Exibe ativas
            (statusEncomenda === true && encomenda.DH_RET && encomenda.DH_RET !== "0001-01-01T00:00:00"); // Exibe retiradas

        return matchBloco && matchUnidade && matchStatus;
    });

    setFilteredEncomendas(filtered);
    setCurrentPage(1); // Reinicia para a primeira página após a filtragem
}, [bloco, unidade, statusEncomenda, encomendas]);

    useEffect(() => {
        if (location.state && location.state.filtroAtivas) {
            // Define "Ativas" como filtro inicial se acessar pelo botão de Encomendas Ativas
            setStatusEncomenda(false); // "false" representa as encomendas ativas
            setStatusSelecionado("false"); // Atualiza o estado do dropdown para refletir "Ativas"
        } else {
            // Define "Todas" como padrão caso a página seja acessada diretamente
            setStatusEncomenda(null);
            setStatusSelecionado(""); // Atualiza o estado do dropdown para refletir "Todas"
        }
    }, [location.state]);


    // Paginação - divisão de páginas
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentEncomendas = filteredEncomendas.slice(indexOfFirstItem, indexOfLastItem);

    // Navegação entre páginas
    const nextPage = () => {
        if (currentPage * itemsPerPage < filteredEncomendas.length) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    // Função auxiliar para expansão dos itens
    const handleExpand = (index) => {
        setExpandedIndex(index === expandedIndex ? null : index);
    };

    // Função auxiliar para formatar os valores
    const formatValue = (value) => {
        // Verifica se o valor é nulo ou indefinido
        if (value === null || value === undefined) {
            return '-';
        }

        // Verifica se o valor é uma string e aplica o trim
        if (typeof value === 'string') {
            if (value.trim() === '' || value === "0001-01-01T00:00:00" || value === "01/01/1, 00:00:00") {
                return '-';
            }
            return converterData(value); // Usa a função converterData para formatar a data
        }

        // Se o valor for um número ou outro tipo, converte para string
        return value.toString();
    };


    return (
        <div className={styles.gerenciarContainer}>
            {/* Filtro */}
            <div className={styles.filterContainer}>
                <form>
                    <div className={styles.formRow}>
                        <label className={styles.label}>
                            Bloco:
                            <input
                                type="text"
                                value={bloco}
                                onChange={(e) => setBloco(e.target.value)}
                                className={styles.inputField}
                            />
                        </label>
                        <label className={styles.label}>
                            Unidade:
                            <input
                                type="text"
                                value={unidade}
                                onChange={(e) => setUnidade(e.target.value)}
                                className={styles.inputField}
                            />
                        </label>
                        <label className={styles.label}>
                            Status:
                            <select
                                value={statusEncomenda === null ? '' : statusEncomenda === false ? 'false' : 'true'}
                                onChange={(e) => setStatusEncomenda(e.target.value === '' ? null : e.target.value === 'true')}
                                className={styles.inputField}
                            >
                                <option value="">Todas</option>
                                <option value="false">Ativas</option>
                                <option value="true">Retiradas</option>
                            </select>
                        </label>
                    </div>
                </form>

            </div>

            {/* Legenda */}
            <div className={styles.legendContainer}>
                <h4>Legenda:</h4>
                <div className={styles.legendGrid}>
                    <div className={styles.legendItem}>
                        <div className={`${styles.legendColor} ${styles.backgroundGreen}`}></div>
                        <p>Ativa recentemente</p>
                    </div>
                    <div className={styles.legendItem}>
                        <div className={`${styles.legendColor} ${styles.backgroundOrange}`}></div>
                        <p>Parada há 1 dia</p>
                    </div>
                    <div className={styles.legendItem}>
                        <div className={`${styles.legendColor} ${styles.backgroundRed}`}></div>
                        <p>Parada há 2 dias</p>
                    </div>
                    <div className={styles.legendItem}>
                        <div className={`${styles.legendColor} ${styles.gray}`}></div>
                        <p>Retirada</p>
                    </div>
                </div>
            </div>


            {/* Lista de encomendas com paginação */}
            <div className={styles.cadastroList}>
                {currentEncomendas.map((encomenda, index) => {
                    // Define a cor de fundo apenas se a encomenda não tiver data de retirada
                    let backgroundClass = '';
                    if (!encomenda.DH_RET || encomenda.DH_RET === "0001-01-01T00:00:00") {
                        const diasAtivos = calcularDiasAtivos(encomenda.DH_GER);
                        if (diasAtivos >= 2) {
                            backgroundClass = styles.backgroundRed; // Vermelho para mais de 2 dias
                        } else if (diasAtivos >= 1) {
                            backgroundClass = styles.backgroundOrange; // Laranja para mais de 1 dia
                        } else {
                            backgroundClass = styles.backgroundGreen; // Verde para menos de 1 dia
                        }
                    }

                    return (
                        <div
                            key={index}
                            className={`${styles.cadastroItem} ${backgroundClass}`}
                            onClick={() => handleExpand(index)}
                        >
                            <div className={styles.blocoUnidade}>
                                <p>
                                    <strong>Bloco:</strong>
                                    {encomenda.BLOCO && encomenda.BLOCO.trim() !== "" ? ` ${encomenda.BLOCO}` : " -"}
                                </p>
                                <p>
                                    <strong>Unidade:</strong> {formatValue(encomenda.NR_CASA)}
                                </p>
                            </div>
                            <p>
                                <strong>Entrega:</strong> {converterData(encomenda.DH_GER)}
                            </p>
                            <p>
                                <strong>Retirada:</strong> {formatValue(encomenda.DH_RET)}
                            </p>

                            {expandedIndex === index && (
                                <div className={styles.expandContent}>
                                    <p>
                                        <strong>Número da Fechadura:</strong> {encomenda.NR_FCH}
                                    </p>
                                    <p>
                                        <strong>Status:</strong> {encomenda.ST_ENC ? "Ativa" : "Pendente"}
                                    </p>
                                    <p>
                                        <strong>Código da Encomenda:</strong> {encomenda.CD_ENC}
                                    </p>
                                </div>
                            )}
                        </div>
                    );
                })}

                {filteredEncomendas.length === 0 && (
                    <p className={styles.mensagemUser}>Nenhuma encomenda encontrada.</p>
                )}
            </div>

            {/* Paginação */}
            <div className={styles.pagination}>
                <button onClick={prevPage} disabled={currentPage === 1}>Anterior</button>
                <span>Página {currentPage} de {Math.ceil(filteredEncomendas.length / itemsPerPage)}</span>
                <button onClick={nextPage} disabled={currentPage * itemsPerPage >= filteredEncomendas.length}>Próxima</button>
            </div>
        </div>
    );
}

export default Historico;
